import { href, useNavigate } from 'react-router';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { sessionQueries } from '~entities/session';
import { clearAllRevisions } from '~shared/api/revisionsKeys';
import { ROUTES } from '~shared/routes';

import { postLoginCip } from '../api';
import { pharmacyStorage } from '../lib/pharmacy-storage';
import { LoginCipFormData } from './login-cip.schema';

export const usePostLoginCip = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: (formData: LoginCipFormData) => postLoginCip(formData),

    onSuccess: ({ pharmacyId }) => {
      // The pharmacy is only known once logged in, so clear the previous session here
      clearAllRevisions(pharmacyId);
      queryClient.invalidateQueries({
        queryKey: sessionQueries.all(pharmacyId),
      });

      pharmacyStorage.setLastPharmacyId(pharmacyId);

      navigate(href(ROUTES.dashboard, { pharmacyId }));
    },
  });

  return {
    loginCip: mutation.mutate,
    reset: mutation.reset,
    isPending: mutation.isPending,
    isError: mutation.isError,
  };
};
